import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export function useManualPageViewTracking(): void {
  const location = useLocation();
  const pageCounterRef = useRef(0);
  const { trackEvent } = useTrackEvent();
  const lastHrefRef = useRef<string | null>(null);

  useEffect(() => {
    pageCounterRef.current += 1;

    // Avoid tracking the same URL multiple times in case of re-renders
    if (window.location.href === lastHrefRef.current) {
      return;
    }
    lastHrefRef.current = window.location.href;

    // Manually sending page view tracking to avoid including the document title,
    // which may contain sensitive information (e.g., project name).
    // We disable default tracking and send a custom event without the title.
    // The complete properties can be seen in: https://amplitude.com/docs/sdks/analytics/browser/migrate-from-marketing-analytics-to-browser-sdk-2-0#updates-to-page-view-tracking
    /* eslint-disable @typescript-eslint/naming-convention */
    trackEvent({
      name: "[Amplitude] Page Viewed",
      props: {
        "[Amplitude] Page Domain": window.location.hostname,
        "[Amplitude] Page Path": window.location.pathname,
        "[Amplitude] Page Location": window.location.href,
        "[Amplitude] Page URL": window.location.origin + window.location.pathname,
        "[Amplitude] Page Counter": pageCounterRef.current,
        // Do not use document.title to avoid leaking project names to Amplitude
        "[Amplitude] Page Title": "Sphere XG",
        // Add this prop to indicate that this is a custom event and not the default page view event
        isCustomEvent: true,
      },
    });
    /* eslint-enable @typescript-eslint/naming-convention */
  }, [location.pathname, trackEvent]);
}
 